import type { DatabasePortItem } from '../models/restaurant.entity';

/**
 * 判断餐厅是否同时配置有效 ECCO 与 EFR 数据隧道。
 * @param databasePort - 餐厅接口返回的旧版单端口或新版多端口配置。
 * @returns 同时存在正数 ECCO、EFR 端口时返回 true。
 */
export function hasDualAnalysisTunnel(databasePort: unknown): boolean {
    if (!Array.isArray(databasePort)) {
        return false;
    }

    /** 当前配置中有效的隧道项目集合。 */
    const validProjects = new Set(
        databasePort
            .filter((item): item is DatabasePortItem & { port: number } => {
                if (typeof item !== 'object' || item === null) {
                    return false;
                }

                /** 待校验的端口项，先固定引用以便 TypeScript 正确收窄 port 类型。 */
                const candidate = item as Partial<DatabasePortItem>;
                return (
                    (candidate.project === 'ECCO' || candidate.project === 'EFR')
                    && typeof candidate.port === 'number'
                    && Number.isFinite(candidate.port)
                    && Number.isInteger(candidate.port)
                    && candidate.port > 0
                );
            })
            .map((item) => item.project),
    );

    return validProjects.has('ECCO') && validProjects.has('EFR');
}
